import axios from './configObra/config-obra'

const defaultRoute = '/insumo-excedente'
const defaultRoutePedido = '/pedido-insumo-excedente'

export default {
  load: async ({ page = 1, codigoInsumo }) => {
    if (codigoInsumo) {
      const { data } = await axios.get(
        `${defaultRoute}?page=${page}&codigoInsumo=${codigoInsumo}`
      )

      return data
    }

    const { data } = await axios.get(`${defaultRoute}/`, {
      params: { page },
    })

    return data
  },

  create: async (insumo, obra, quantidade) => {
    const { data } = await axios.post(defaultRoute, {
      insumo: insumo._id,
      obra: obra._id,
      quantidade: Number(quantidade),
    })

    return data
  },

  edita: async (id, quantidade) => {
    const { data } = await axios.patch(`${defaultRoute}/${id}`, {
      quantidade: Number(quantidade),
    })

    return data
  },

  apaga: async (id) => {
    const { data } = await axios.delete(`${defaultRoute}/${id}`)

    return data
  },

  getById: async (id) => {
    const { data } = await axios.get(`${defaultRoute}/${id}`)

    return data
  },

  approval: async (id) => {
    const { data } = await axios.patch(`${defaultRoutePedido}/${id}/`, {
      status: 'aprovado',
    })

    return data
  },

  reproval: async (id) => {
    const { data } = await axios.patch(`${defaultRoutePedido}/${id}/`, {
      status: 'reprovado',
    })

    return data
  },

  newRequest: async (item) => {
    const { data } = await axios.post(`${defaultRoutePedido}/`, {
      insumoExcedente: item.insumoExcedente,
      quantidade: Number(item.quantidade),
      obraRequerente: item.obraRequerente,
    })

    return data
  },
  
  deleteRequest: async (item) => {
    const { data } = await axios.delete(`${defaultRoutePedido}/${item}`)

    return data
  },
}
